"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializerMiddleware = void 0;

var tslib_1 = require("tslib");

function deserializerMiddleware(options, deserializer) {
  var _this = this;

  return function (next) {
    return function (args) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var response, parsed;
        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , next(args)];

            case 1:
              response = _a.sent().response;
              return [4
              /*yield*/
              , deserializer(response, options)];

            case 2:
              parsed = _a.sent();
              return [2
              /*return*/
              , {
                response: response,
                output: parsed
              }];
          }
        });
      });
    };
  };
}

exports.deserializerMiddleware = deserializerMiddleware;